import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { rootReducer } from '@wellesley/store'

export type BookmarksState = {
  data: {
    savedPosts: string[]
    removedPosts: string[]
  }
}

const initialState: BookmarksState = {
  data: {
    savedPosts: [],
    removedPosts: [],
  },
}

export const bookmarksSlice = createSlice({
  name: 'bookmarks',
  initialState,
  reducers: {
    savePost: (state, { payload: postId }: PayloadAction<string>) => {
      state.data = {
        ...state.data,
        removedPosts: state.data.removedPosts.filter((id) => id !== postId),
        savedPosts: [...(state.data?.savedPosts || []), postId],
      }
    },
    removePost: (state, { payload: postId }: PayloadAction<string>) => {
      state.data = {
        ...state.data,
        savedPosts: state.data.savedPosts.filter((id) => id !== postId),
        removedPosts: [...(state.data?.removedPosts || []), postId],
      }
    },
  },
  selectors: {
    selectIsSavedPost: (state, postId: string) =>
      !!state.data?.savedPosts.find((id) => id === postId),
    selectIsRemovedPost: (state, postId: string) =>
      !!state.data?.removedPosts.find((id) => id === postId),
  },
}).injectInto(rootReducer)
